var map = {
	"./img1_mob@2x.webp": 5593,
	"./img2_mob@2x.webp": 8018,
	"./img3_mob@2x.webp": 2031,
	"./img4_mob@2x.webp": 9264,
	"./img5_mob@2x.webp": 1237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7850;